export const ComponentList = [
  'Guide',
  'FormLayout',
  'FormTableLayout',
  'FormTableLayoutActions',
  'FormTableLayoutSingle',
  'FormTableLayoutFields',
  'DebounceInput',
  'DataSelect',
  'DataCascader',
  'DataTable',
  'DataDictionary',
  'LoadingButton',
  'Amount',
  'Enum',
  'MonthPicker',
  'DateFormatPicker',
  'DateRangeFormatPicker',
  'NumberRangePicker',
  'NumberStepPicker',
  'UploadFile',
  'TableColumnBtn',
  'RichText',
  'PasswordInput',
  'Description',
  'CountDown',
  'Clipboard',
  'Utils',
]
